// The TableOfContentsHook highlights the opportunity details sidebar link for a section when
// the section is in the viewport.
// See https://garden.bradwoods.io/notes/javascript/web-api/intersection-observer/table-of-contents

const TableOfContentsHook = {
  mounted() {
    const links = document.querySelectorAll("#details-overview-sidebar a");
    const sections = document.querySelectorAll("#overview-content > section");
    const options = {
      rootMargin: "-35% 0px -65% 0px",
      threshold: 0,
    };
    const ACTIVE_CLASS = ["text-gray-900", "border-gray-900", "border-l-2"];

    const tableOfContentsMap = [...sections].reduce(
      (acc, section, i) => ({
        ...acc,
        [section.id]: links[i],
      }),
      {},
    );

    let selectedId = sections[0].id;

    function removeHighlight(id) {
      tableOfContentsMap[id].classList.remove(...ACTIVE_CLASS);
    }

    function addHighlight(id) {
      tableOfContentsMap[id].classList.add(...ACTIVE_CLASS);
    }

    function onObserve(entries, _observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const { id } = entry.target;
          removeHighlight(selectedId);
          addHighlight(id);
          selectedId = id;
        }
      });
    }

    this.observer = new IntersectionObserver(onObserve, options);

    sections.forEach((section) => {
      this.observer.observe(section);
    });

    addHighlight(selectedId);
  },
  destroyed() {
    this.observer.disconnect();
  },
};

// TODO: Unify these so they can take arbitrary selectors.
const DealUpdatesTableOfContentsHook = {
  mounted() {
    const links = document.querySelectorAll("#deal-updates-table-of-contents a");
    const sections = document.querySelectorAll("#deal-updates-list-content > section");
    const options = {
      rootMargin: "-35% 0px -65% 0px",
      threshold: 0,
    };
    const ACTIVE_CLASS = ["text-gray-900", "border-gray-900", "border-l-2"];

    const tableOfContentsMap = [...sections].reduce(
      (acc, section, i) => ({
        ...acc,
        [section.id]: links[i],
      }),
      {},
    );

    let selectedId = sections[0].id;

    function removeHighlight(id) {
      tableOfContentsMap[id].classList.remove(...ACTIVE_CLASS);
    }

    function addHighlight(id) {
      tableOfContentsMap[id].classList.add(...ACTIVE_CLASS);
    }

    function onObserve(entries, _observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const { id } = entry.target;
          removeHighlight(selectedId);
          addHighlight(id);
          selectedId = id;
        }
      });
    }

    this.observer = new IntersectionObserver(onObserve, options);

    sections.forEach((section) => {
      this.observer.observe(section);
    });

    addHighlight(selectedId);
  },
  destroyed() {
    this.observer.disconnect();
  },
};

// I couldn't get the above approach to work - this uses basically the same
// approach with less data structures involved.
// Gotten from CSSTricks: https://css-tricks.com/table-of-contents-with-intersectionobserver/
const AdminTableOfContentsHook = {
  mounted() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.isIntersecting) {
            document
              .querySelector(`li a[href="#${id}"]`)
              .classList.add("bg-gray-100");
          } else {
            element = document.querySelector(`li a[href="#${id}"]`);
            if (element) {
              element.classList.remove("bg-gray-100");
            }
          }
        });
      },
      { rootMargin: "-25% 0px", threshold: 0.15 },
    );

    document.querySelectorAll("section[id]").forEach((section) => {
      this.observer.observe(section);
    });
  },
  destroyed() {
    this.observer.disconnect();
  },
};

function nextUntil(elem, selector) {
  let siblings = [];

  elem = elem.nextElementSibling;

  while (elem) {
    if (elem.matches(selector)) break;
    siblings.push(elem);
    elem = elem.nextElementSibling;
  }
  return siblings;
}

const ArticleTableOfContentsHook = {
  mounted() {
    this.observer = new IntersectionObserver(
      (entries) => {
        let anEntryIsIntersectiing = false;
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.isIntersecting && !anEntryIsIntersectiing) {
            document
              .querySelector(`a[href="#${id}"]`)
              .classList.add(
                "border-l-2",
                "border-l-[#27272A]",
                "text-[#18181B]",
              );
            anEntryIsIntersectiing = true;
          } else {
            element = document.querySelector(`a[href="#${id}"]`);
            if (element) {
              element.classList.remove(
                "border-l-2",
                "border-l-[#27272A]",
                "text-[#18181B]",
              );
            }
          }
        });
      },
      { rootMargin: "-25% 0px", threshold: 0.15 },
    );

    document.querySelectorAll("h3[id]").forEach((sectionHeader) => {
      const nextChildren = nextUntil(sectionHeader, "h3[id]");
      const wrapper = document.createElement("div");
      wrapper.setAttribute("id", sectionHeader.id);
      wrapper.setAttribute("class", "toc-section mb-16");
      sectionHeader.parentNode.insertBefore(wrapper, sectionHeader);
      wrapper.appendChild(sectionHeader);
      nextChildren.forEach((nextChild) => {
        wrapper.appendChild(nextChild);
      });
      this.observer.observe(wrapper);
    });
  },
  destroyed() {
    this.observer.disconnect();
  },
};

export {
  TableOfContentsHook,
  AdminTableOfContentsHook,
  ArticleTableOfContentsHook,
  DealUpdatesTableOfContentsHook,
};
